import "../style/resume.css";
import React from "react";
import Footer from "./footer";
import { FiDownload } from "react-icons/fi";

export default function Resume() {
  return (
    <main className="resume">
      <header className="resume-header">
        <div className="resume-title">
          <h1>Kim Nguyen</h1>
          <p>Machine Learning · KTH</p>
          <p>Data Science • Machine Learning • Full-Stack</p>
        </div>
        <img src="/kim_pic.png" alt="Kim Nguyen" className="resume-photo" />
      </header>
      <div className="cv-wrap">
        <a
          href="/kim_nguyen_cv.pdf"
          target="_blank"
          rel="noopener"
          className="cv-card"
        >
          <img src="/kim.png" alt="CV preview" className="cv-image" />
        </a>
      </div>{" "}
      <div className="button">
        <a href="/kim_nguyen_cv.pdf" download className="rectangle">
          <FiDownload className="download-icon-2" />
          <p className="rectangle-text">Download CV</p>
        </a>
      </div>
      <div className="footer">
        <Footer />
      </div>
    </main>
  );
}
